import { Controller } from "@hotwired/stimulus"

// Submits the surrounding form, e.g. the "Auf Anfrage" filter checkbox. The task form's status
// dropdown belongs to edit_task_controller.
export default class extends Controller {
  submit() {
    this.element.closest("form").requestSubmit()
  }
}
